import Layout from "@/layout";
export default {
  path: "Customer",
  component: () => import('@/views/AppMain/index'),
  name: "Customer",
  hidden: false,
  alwaysShow: true,
  meta: {
    title: "客户管理",
    keepAlive: false,
    icon: '1017',
    activeIcon: '1016',
    // activeMenu: '/HeadOfficeManagement/BasicDataManage/BasicData'
  },
  children: [
    {
      hidden: false,
      path: "CustomerProfile",
      component: () => import("@/views/HeadOfficeManagement/Customer/CustomerProfile"),
      name: "CustomerProfile",
      meta: {
        title: "客户档案",
        keepAlive: false,
      },
    },
    // {
    //   hidden: false,
    //   path: "UserLevel",
    //   component: () => import("@/views/HeadOfficeManagement/Customer/UserLevel"),
    //   name: "UserLevel",
    //   meta: {
    //     title: "用户等级",
    //     keepAlive: false,
    //   },
    // },
    // {
    //   hidden: false,
    //   path: "Label",
    //   component: () => import("@/views/HeadOfficeManagement/Customer/Label"),
    //   name: "Label",
    //   meta: {
    //     title: "标签",
    //     keepAlive: false,
    //   },
    // },
    {
      hidden: true,
      path: "CustomerProfileDetail",
      component: () => import("@/views/HeadOfficeManagement/Customer/CustomerProfileDetail"),
      name: "CustomerProfileDetail",
      meta: {
        title: "客户详情",
        keepAlive: true,
        activeMenu: '/HeadOfficeManagement/Customer/CustomerProfile'
      },
    },
  ]
};
